module.exports = __webpack_public_path__ + "img/call-1.bb1026a5.png";